//  CreateTests.js
//
//  Updated 2/2.
//
//  Abstract: Create new tests functional component. CRUD Firestore and Firebase.

//	React
import axios from 'axios';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { authMiddleware } from '../../../services/auth/auth.js';

// Components
import CreateIndividualTest from './CreateIndividualTest/CreateIndividualTest.js';
import CreateBatchTests from './CreateBatchTests/CreateBatchTests.js';

//	Material-ui components
import {
	Toolbar,
	AppBar,
	Tabs,
	Tab,
	Box,
	Typography,
	CircularProgress,
	Card,
	CardActions,
	CardContent,
	Divider,
	Button,
	Grid,
	TextField,
	makeStyles,
	FormControl,
	Select,
	InputLabel,
	MenuItem,
	Container,
	Paper
} from '@material-ui/core';

//	Date picker imports
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from '@material-ui/pickers';

//	CSS Styles
const useStyles = makeStyles((theme) => ({
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
		// marginTop: '50px'
	},
	details: {
		display: 'flex'
	},
	avatar: {
		height: 110,
		width: 100,
		flexShrink: 0,
		flexGrow: 0
	},
	locationText: {
		paddingLeft: '15px'
	},
	buttonProperty: {
		position: 'absolute',
		top: '50%'
	},
	uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	},
	progess: {
		position: 'absolute'
	},
	uploadButton: {
		marginLeft: '8px',
		margin: theme.spacing(1)
	},
	customError: {
		color: 'red',
		fontSize: '0.8rem',
		marginTop: 10
	},
	submitButton: {
		marginTop: '10px'
	},
	// toolbar: { marginTop: '100px', :},
}));

export default function CreateTests(props) {

	//  CSS styles
	const classes = useStyles();

	//	Set state
	const [patientId, setPatientId] = useState('');
	const [testId, setTestId] = useState('');
	const [patchIdsArray, setPatchIdsArray] = useState([]);
	const [plannedTestStartDate, setPlannedTestStartDate] = useState('');
	const [errors, setErrors] = useState([]);
	const [isUiLoading, setIsUiLoading] = useState(false);
	const [isButtonLoading, setIsButtonLoading] = useState(false);
	const [tabValue, setTabValue] = useState(0);
	const [selectedDate, setSelectedDate] = useState(new Date('2014-08-18T21:11:54'));

	//	Event handlers
	const handleDateChange = (date) => {
		setSelectedDate(date);
	};
	function handlePatientIdChange(event) {
		setPatientId(event.target.value);
	}
	function handleTestIdChange(event) {
		setTestId(event.target.value);
	}
	function handlePatchIdsArrayChange(event) {
		setPatchIdsArray(event.target.value);
	}
	function handlePlannedTestStartDateChange(event) {
		setPlannedTestStartDate(event.target.value);
	}
	function handleErrorsChange(event) {
		setErrors([event.target.value]);
	}
	function handleTabChange(event, newValue) {
		setTabValue(newValue);
	};
	function handleCreateTestSubmit(event) {
		authMiddleware(props.history);
		event.preventDefault();
		const testData = {
			patientId: patientId,
			testId: testId,
			patchIdsArray: patchIdsArray,
			plannedTestStartDate: plannedTestStartDate
		};
		let options = {};
		options = {
			url: `/test`,
			method: 'post',
			data: testData
		}
		const authToken = localStorage.getItem('AuthToken');
		axios.defaults.headers.common = { Authorization: `${authToken}` };
		axios(options)
			.then(() => {
			})
			.catch((error) => {
				setErrors(error.response.data)
				console.log(error);
			});
	};

	//	Define tab picker
	function TabPanel(props) {
		const { children, value, index, ...other } = props;
		return (
			<div
				role="tabpanel"
				hidden={value !== index}
				id={`simple-tabpanel-${index}`}
				aria-labelledby={`simple-tab-${index}`}
				{...other}
			>
				{value === index && (
					<Box p={3}>
						<Typography>{children}</Typography>
					</Box>
				)}
			</div>
		);
	}

	TabPanel.propTypes = {
		children: PropTypes.node,
		index: PropTypes.any.isRequired,
		tabValue: PropTypes.any.isRequired,
	};

	function tabPanelProps(index) {
		return {
			id: `simple-tab-${index}`,
			'aria-controls': `simple-tabpanel-${index}`,
		};
	}

	//	Render loading screen
	if (isUiLoading) {
		return (
			<main className={classes.content}>
				<div className={classes.toolbar} />
				{isUiLoading && <CircularProgress size={16} className={classes.uiProgess} />}
			</main>
		);
	} else {
		//	Render tab view of individual and batch tests
		return (
			<>
				<Typography variant="h5">
					Create Tests
					</Typography>
				<AppBar position="static" elevation={0} >
					<Tabs value={tabValue} onChange={handleTabChange} aria-label="tab-picker">
						<Tab label="Individual" {...tabPanelProps(0)} disableRipple />
						<Tab label="Batch" {...tabPanelProps(1)} disableRipple />
					</Tabs>
				</AppBar>
				<Divider />
				<TabPanel value={tabValue} index={0}>
					<CreateIndividualTest isButtonLoading={isButtonLoading} patientId={patientId} testId={testId} patchIdsArray={patchIdsArray} plannedTestStartDate={plannedTestStartDate} errors={errors} onPatientIdChange={handlePatientIdChange} onTestIdChange={handleTestIdChange} onPatchIdsArrayChange={handlePatchIdsArrayChange} onPlannedTestStartDateChange={handlePlannedTestStartDateChange} onErrorsChange={handleErrorsChange} onCreateTestSubmit={handleCreateTestSubmit} />
				</TabPanel>
				<TabPanel value={tabValue} index={1}>
					<CreateBatchTests />
				</TabPanel>
			</>
		);
	}
};